export const paymentTypes = {
    DONATION: "donation",
    SALE: "sale"
}